/* eslint-disable */
import { padEnd, padStart } from '@/common/miscutil'
import fetch from 'isomorphic-fetch'
import Promise from 'promise-polyfill'

// 更新padStart 和 padEnd
if (!String.prototype.padStart) {
  String.prototype.padStart = padStart
}

if (!String.prototype.padEnd) {
  String.prototype.padEnd = padEnd
}

// 更新Promise 和 fetch
if (!window.Promise) {
  console.log('Promise is null')
  window.Promise = Promise
}

if (!window.fetch) {
  console.log('fetch is null')
  window.fetch = fetch
}



// WEBPACK FOOTER //
// ./src/common/compatUtil.js